/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';
const propTypes = {
  colors: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired,
  selected: PropTypes.string,
  disabled: PropTypes.bool,
  elementRef: PropTypes.func,
  label: PropTypes.string,
  popoverScreenReaderLabel: PropTypes.string,
  colorScreenReaderLabel: PropTypes.func,
  colorMixerSettings: PropTypes.shape({
    addNewPresetButtonScreenReaderLabel: PropTypes.string.isRequired,
    selectColorLabel: PropTypes.string.isRequired,
    removeColorLabel: PropTypes.string.isRequired,
    onPresetChange: PropTypes.func,
    popoverAddButtonLabel: PropTypes.string.isRequired,
    popoverCloseButtonLabel: PropTypes.string.isRequired,
    maxHeight: PropTypes.string,
    colorMixer: PropTypes.shape({
      withAlpha: PropTypes.bool,
      rgbRedInputScreenReaderLabel: PropTypes.string.isRequired,
      rgbGreenInputScreenReaderLabel: PropTypes.string.isRequired,
      rgbBlueInputScreenReaderLabel: PropTypes.string.isRequired,
      rgbAlphaInputScreenReaderLabel: PropTypes.string.isRequired,
      colorSliderNavigationExplanationScreenReaderLabel: PropTypes.string.isRequired,
      alphaSliderNavigationExplanationScreenReaderLabel: PropTypes.string.isRequired,
      colorPaletteNavigationExplanationScreenReaderLabel: PropTypes.string.isRequired
    }).isRequired,
    colorContrast: PropTypes.shape({
      firstColor: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      successLabel: PropTypes.string.isRequired,
      failureLabel: PropTypes.string.isRequired,
      normalTextLabel: PropTypes.string.isRequired,
      largeTextLabel: PropTypes.string.isRequired,
      graphicsTextLabel: PropTypes.string.isRequired,
      firstColorLabel: PropTypes.string.isRequired,
      secondColorLabel: PropTypes.string.isRequired
    })
  })
};
const allowedProps = ['colors', 'disabled', 'elementRef', 'label', 'colorMixerSettings', 'onSelect', 'popoverScreenReaderLabel', 'selected', 'colorScreenReaderLabel'];
export { propTypes, allowedProps };